import '../../themes/global.scss';
import '../../themes/job_summary.scss';
import '../../themes/payment.scss';

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import history from '../../history';
import {
  getAllPaymnets,
  GET_ALL_PAYMENTS_ACTION,
  DELETE_PAYMENT_ACTION,
  deletePayment,
  selectPayment,
  SELECT_PAYMENT_ACTION,
  verifyBank,
  VERIFY_BANK_ACTION,
  showMessage,
  hideMessage,
} from '../../actions';
import { Colors } from '../../themes/colors';
import { createLoadingSelector } from '../../api/selectors';
import CustomSpinner from '../../commonComponents/CustomSpinner';
import BackButton from '../../commonComponents/BackButton';
import MobileAppModal from '../../commonComponents/MobileAppModal';

export default function Payment() {
  const dispatch = useDispatch();

  const allPayments = useSelector((state) => state.payments.allPayments);
  const loadingSelector = createLoadingSelector([
    GET_ALL_PAYMENTS_ACTION,
    SELECT_PAYMENT_ACTION,
    DELETE_PAYMENT_ACTION,
    VERIFY_BANK_ACTION,
  ]);
  const isLoading = useSelector((state) => loadingSelector(state));

  const [openVerify, setOpenVerify] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [paymentId, setPaymentId] = useState('');

  useEffect(() => {
    dispatch(getAllPaymnets());
  }, []);

  const closeModal = () => {
    setModalIsOpen(false);
    setOpenVerify(false);
    setPaymentId('');
  };

  const triggerMessage = (paymentId) => {
    dispatch(
      showMessage({
        title: 'Confirm Delete',
        message: 'Are you sure you want to delete this payment method?',
        isError: true,
        popupProps: {
          leftButtonText: 'Go Back',
          leftButtonAction: () => dispatch(hideMessage()),
          rightButtonText: 'Remove',
          rightButtonAction: () => {
            confirmDelete(paymentId);
            dispatch(hideMessage());
          },
        },
      }),
    );
  };

  const selectedCard = (paymentId) => {
    dispatch(selectPayment({ paymentId }));
  };

  const verifyBankAccount = (data) => {
    dispatch(verifyBank({ paymentId, data }));
    closeModal();
  };

  const confirmDelete = (paymentId) => {
    dispatch(deletePayment({ paymentId }));
  };

  const isVerifyOrMakeDefault = (card) => {
    if (card.type === 'bank_account' && card.status === 'new') {
      return (
        <p
          className="global_font f-16 f-dark bold"
          style={{ color: Colors.primary_500, cursor: 'pointer' }}
          onClick={() => {
            setPaymentId(card.id);
            setOpenVerify(true);
          }}
        >
          Verify
        </p>
      );
    }
    return (
      <p
        className="global_font f-16 f-dark bold"
        style={{ color: Colors.primary_500, cursor: 'pointer' }}
        onClick={() => selectedCard(card.id)}
      >
        Make Default
      </p>
    );
  };

  const renderView = () => (
    <div
      style={{
        margin: '20px 40px',
      }}
    >
      <BackButton url="/dashboard/account" />

      <h1 className="global_font f-dark" style={{ marginLeft: 30 }}>
        Payment Method
      </h1>

      {allPayments.map((card) => (
        <div
          style={{
            width: 500,
            display: 'flex',
            justifyContent: 'space-between',
            margin: '5px 20px',
            flexDirection: 'row',
          }}
          key={card.id}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              opacity: card.status === 'new' ? 0.5 : 1,
            }}
          >
            <img
              src={
                card.type === 'card'
                  ? require('../../images/Credit_Card_Icon.png')
                  : require('../../images/banklime.png')
              }
              style={{ width: 35, height: 35, marginRight: 10 }}
              alt="credit_card"
            />
            <p
              className="global_font f-dark f-18"
              style={{ fontWeight: 400 }}
            >
              {card.type === 'card' ? card.brand : 'Bank '}
              {' '}
              ••••
              {card.last4}
            </p>
          </div>
          {card.is_selected ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img
                src={require('../../images/Check_Icon.png')}
                style={{ width: 35, height: 35, marginRight: 20 }}
                alt="check"
              />
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {isVerifyOrMakeDefault(card)}
              <p
                className="global_font f-16 f-dark bold"
                style={{
                  color: Colors.error_500,
                  marginLeft: 10,
                  marginRight: 20,
                  cursor: 'pointer',
                }}
                onClick={() => triggerMessage(card.id)}
              >
                Delete
              </p>
            </div>
          )}
        </div>
      ))}
      {allPayments.length === 0 ? (
        <div
          style={{
            width: 500,
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            margin: '10px 30px',
          }}
        >
          <img
            src={require('../../images/Credit_Card_Icon.png')}
            style={{ width: 35, height: 35, marginRight: 10 }}
            alt="credit_card"
          />
          <p className="global_font f-dark" style={{ fontSize: 20 }}>
            Please add a credit card
          </p>
        </div>
      ) : (
        <div />
      )}
      <div className="line" style={{ width: 500 }} />
      <div
        style={{
          width: 500,
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          margin: '10px 30px',
          cursor: 'pointer',
        }}
        onClick={() => history.push('/dashboard/payment/add')}
      >
        <img
          src={require('../../images/Add_Card.png')}
          style={{
            width: 35,
            height: 35,
            marginRight: 10,
          }}
          alt="add"
        />
        <p className="global_font f-dark" style={{ fontSize: 20 }}>
          Add Payment Method
        </p>
      </div>
      <div
        style={{
          width: 500,
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          margin: '10px 30px',
          cursor: 'pointer',
        }}
        onClick={() => history.push('/invoices')}
      >
        <img
          src={require('../../images/banklime.png')}
          style={{
            width: 35,
            height: 35,
            marginRight: 10,
          }}
          alt="add"
        />
        <p className="global_font f-dark" style={{ fontSize: 20 }}>
          See Invoices
        </p>
      </div>
    </div>
  );

  if (isLoading) {
    return (
      <div className="component_container">
        <div className="floating_container">
          <CustomSpinner isLoading={isLoading} />
        </div>
      </div>
    );
  }

  return (
    <div className="component_container">
      <div
        className="floating_container"
        style={{ justifyContent: 'flex-start' }}
      >
        {renderView()}

        <MobileAppModal
          show={modalIsOpen}
          closeModal={closeModal}
          content="mobile"
        />
        <MobileAppModal
          show={openVerify}
          closeModal={closeModal}
          content="bankVerification"
          result={verifyBankAccount}
        />
      </div>
    </div>
  );
}
